import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/fireLogo.png'
import _imports_1 from '../../../assets/fireLogoCom.png'
import _imports_2 from '../../../assets/game/mobile_more.png'
import _imports_3 from '../../../assets/game/mobile_recommendedGame.png'
import _imports_4 from '../../../assets/game/mobile_hotGame.png'
import _imports_5 from '../../../assets/game/mobile_gzh.png'
import _imports_6 from '../../../assets/game/mobile_kfWechat.png'


const _withScopeId = n => (_pushScopeId("data-v-e29e21e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav_left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "nav_right" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "" }, "首页")
], -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "swiper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "recommendedGame" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "gameInfo" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty" }, null, -1))
const _hoisted_19 = { class: "popularGame" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_21 = { class: "gameCard" }
const _hoisted_22 = { class: "cardInfo" }
const _hoisted_23 = ["src"]
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"ourInfo\" data-v-e29e21e2><div class=\"ourInfo_l\" data-v-e29e21e2><img src=\"" + _imports_5 + "\" alt=\"\" data-v-e29e21e2><p data-v-e29e21e2>关注我们</p><p data-v-e29e21e2>官方微信公众号</p></div><div class=\"ourInfo_r\" data-v-e29e21e2><img src=\"" + _imports_6 + "\" alt=\"\" data-v-e29e21e2><p data-v-e29e21e2>更多详情添加</p><p data-v-e29e21e2>专业客服微信号</p></div></div><p class=\"throughLine\" data-v-e29e21e2></p><div class=\"bottom\" data-v-e29e21e2><img src=\"" + _imports_0 + "\" alt=\"\" data-v-e29e21e2><p data-v-e29e21e2><span data-v-e29e21e2>燃火游戏</span> | 版权所有 | <a href=\"https://beian.miit.gov.cn/\" data-v-e29e21e2>苏ICP备2022048589号-2</a></p><p data-v-e29e21e2>苏州燃火网络科技有限公司</p><p data-v-e29e21e2>用户隐私协议 | 用户服务协议 | 投诉信箱 | 合作信箱</p></div>", 3)

import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { detectPhone } from "@/utils/device";

import { useGameStore } from "../../../store/gameStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'homepage',
  setup(__props) {

const router = useRouter();
const state: any = reactive({
  moreInfoFlag: false,
  down: [],
  gameslide: [],
  lists: [],
  rmgames: [],

  phoneType: "android",
});

let gameStore = useGameStore();

const { downStore } = storeToRefs(gameStore);

// console.log('gameList', gameList)
onMounted(() => {
  // console.log("onmounted------------");
  getInfo();

  state.phoneType = detectPhone();

  // console.log("detectPhone----", state.phoneType);
});

// 展示更多信息
const showSomeElse = () => {
  state.moreInfoFlag = !state.moreInfoFlag;
  //开启延迟定时器，如果存在定时器，先清除，再开启
  if (closeMoreInfo) {
    clearTimeout(closeMoreInfo);
    closeMoreInfo();
  } else {
    closeMoreInfo();
  }
};
const fullScreenClick = () => {
  state.moreInfoFlag = false;
};

// 添加一个延时器，3s后关闭
var closeMoreInfo: any = null;
closeMoreInfo = () => {
  setTimeout(() => {
    state.moreInfoFlag = false;
  }, 3000);
};

// 跳转到更多游戏
const goMoreGame = () => {
  router.push({
    path: "/mobileView/gameCenter",
  });
};

const getInfo = async () => {
  fetch("http://api.98pk.com/index/index/indexlists", {
    method: "POST",
    headers: {
      "Content-Type": "application.json()",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      // console.log("data---------", data.data),
      (state.down = data.data.down),
        (downStore.value = data.data.down),
        (state.gameslide = data.data.wapgameSlide),
        (state.lists = data.data.lists),
        (state.rmgames = data.data.rmgames);

      // 如果regames是3或者3的倍数就完整展示，如果不是，就只保留3n个
      if (state.rmgames % 3 == 0) {
        state.rmgames = state.rmgames;
      } else {
        state.rmgames = state.rmgames.slice(
          0,
          3 * Math.floor(state.rmgames.length / 3)
        );
      }
      // console.log("轮播图数据-------------", state.gameslide);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("div", {
    class: "allContent",
    onClick: _withModifiers(fullScreenClick, ["stop"])
  }, [
    _createVNode(_component_van_sticky, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _imports_2,
              alt: "",
              onClick: _withModifiers(showSomeElse, ["stop"])
            }, null, 8, _hoisted_5),
            _withDirectives(_createElementVNode("ul", null, [
              _hoisted_6,
              _createElementVNode("li", null, [
                _createElementVNode("a", { onClick: goMoreGame }, "游戏")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: state.down.qqkf
                }, "QQ客服", 8, _hoisted_7)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: state.down.lxkf
                }, "微信客服", 8, _hoisted_8)
              ])
            ], 512), [
              [_vShow, state.moreInfoFlag]
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_van_swipe, {
          class: "my-swipe",
          autoplay: 3000,
          "indicator-color": "#FFBC07"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.gameslide, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_swipe_item, {
                key: index + 'slid_img'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item.slide_pic
                  }, null, 8, _hoisted_11)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lists, (item, index) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createElementVNode("img", {
                src: item.pic3,
                alt: ""
              }, null, 8, _hoisted_14),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h4", null, _toDisplayString(item.gamename), 1),
                _createElementVNode("p", null, _toDisplayString(item.welfare), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: item.android_url
                  }, "安卓下载", 8, _hoisted_16),
                  _createElementVNode("a", {
                    href: item.ios_url
                  }, "IOS下载", 8, _hoisted_17)
                ])
              ])
            ]))
          }), 256))
        ]),
        _createElementVNode("p", { onClick: goMoreGame }, "更多游戏")
      ])
    ]),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.rmgames, (item, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("img", {
              src: item.pic1,
              alt: ""
            }, null, 8, _hoisted_23),
            _createElementVNode("h4", null, _toDisplayString(item.gamename), 1),
            _createElementVNode("p", null, _toDisplayString(item.welfare), 1),
            _createElementVNode("div", null, [
              (state.phoneType == 'android')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item.android_url
                  }, "下载游戏", 8, _hoisted_24))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: item.ios_url
                  }, "下载游戏", 8, _hoisted_25))
            ])
          ]))
        }), 256))
      ]),
      _hoisted_26
    ])
  ], 8, _hoisted_1))
}
}

})